import { render, staticRenderFns } from "./BlackLists.vue?vue&type=template&id=7cb2afbe"
import script from "./BlackLists.vue?vue&type=script&lang=js"
export * from "./BlackLists.vue?vue&type=script&lang=js"
import style0 from "./BlackLists.vue?vue&type=style&index=0&id=7cb2afbe&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports